import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from 'src/environments/environment';
import { GlobalService } from "./global.service";
import { catchError, map } from "rxjs/operators";
import { throwError } from "rxjs";
const devUrl = environment.backendurl


@Injectable({
    providedIn: 'root'
})

export class ImportCandidateService {


    constructor(private http: HttpClient) { }


    /**
     * Upload bulk resume to create candidate
     * @param data 
     * @returns 
     */
    uploadBulkResume(data: any) {
        const url = devUrl + "/candidate/import/parseresume"
        let formData: FormData = new FormData();
        formData.append('resume', data);
        return this.http.post<any>(url, formData, { observe: 'response' }).pipe(map(response => ({ ...response, statusCode: response.status }))
            , catchError((err: HttpErrorResponse) => throwError(err)));
    };


    /**
     * Create bulk candidate with uploaded resume
     * @param data 
     * @param jobid 
     * @returns 
     */
    createBulkCandidate(data: any) {
        const url = devUrl + `/candidate/screenai/import/bulk`;
        return this.http.post<any>(url, data, { observe: 'response' }).pipe(map(response => ({ ...response, statusCode: response.status }))
            , catchError((err: HttpErrorResponse) => throwError(err)));
    };

    /**
     * 
     * @param data 
     * @returns 
     */
    enrichBulkLinkedinUrls(data: any){
        const url = devUrl + `/candidate/screenai/import/enrich-linkedinurls`;
        return this.http.post<any>(url, data, { observe: 'response' }).pipe(map(response => ({ ...response, statusCode: response.status }))
            , catchError((err: HttpErrorResponse) => throwError(err)));
    }


    /**
     * Bulk create candidates via linked csv import
     * @param csvFile csv file
     * @param projectnumber project number
     * @returns Observable<Object>
     */
    createCandidatesViaLinkedinCSVImport(csvFile: File, projectnumber: string = '') {
        const url = devUrl + `/candidate/screenai/import/parsecsv`;
        const formData: FormData = new FormData();
        formData.append('linkedin_csv', csvFile);
        formData.append('projectnumber', projectnumber);
        return this.http.post(url, formData, { observe: 'response' }).pipe(
            map(response => ({ ...response, statusCode: response.status }))
            , catchError((err: HttpErrorResponse) => throwError(err)));
    };


    /**
     * Download sample csv file
     * @returns Observable<Object>
     */
    downloadSampleCsvFile() {
        var url = devUrl + `/download/samplecsv`;
        return this.http.get(url, { responseType: 'blob' }).pipe(
            map((response: any) => { return response })
            , catchError(GlobalService.handleError('resumeurl', url)));
    };

}